import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLoaderData, useNavigate } from 'react-router-dom';

import Location from '@r6digital/rapidstor-types/react/entities/Location';
import Persona from '@r6digital/rapidstor-types/types/Persona';

import store from '../store';
import {
    selectIsAshford,
    selectPersonaId,
    selectStorageType,
    setIsAshford,
    setStorageSize,
    setStorageType,
} from '../store/bookingSlice';

import {
    selectAllLocations,
    useGetPersonasQuery,
} from '../features/rapidstor/rapidstorApiSlice';

import classes from './JourneySelectors.module.scss';

import { ReactComponent as PinIcon } from '../assets/icon-pin-grey.svg';
import { findPersonaId } from '../features/helpers';

interface Props {
    locationSelect?: boolean;
    storageTypeSelect?: boolean;
    hideSelectors?: boolean;
    setCurrentPersonaId?: (id: string | null) => void;
}

function JourneySelectors({
    storageTypeSelect,
    setCurrentPersonaId,
    hideSelectors,
}: Props) {
    const locations = selectAllLocations(store.getState());
    const location = useLoaderData() as Location;
    const navigate = useNavigate();
    const storageType = useSelector(selectStorageType);
    const personaId = useSelector(selectPersonaId);
    const isAshford = useSelector(selectIsAshford);

    const { data: personas } = useGetPersonasQuery(location.locationCode);

    useEffect(() => {
        if (!personaId && personas && setCurrentPersonaId) {
            setCurrentPersonaId(findPersonaId('personal', personas));
        }
        // if (!storageSize && !storageType) {
        //     store.dispatch(setStorageSize(999));
        //     store.dispatch(setStorageType('personal'));
        // }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [personas]);

    const changeLocation = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const locationSlug = event.target.value;
        store.dispatch(setStorageSize(null));
        store.dispatch(setStorageType(null));
        if (locationSlug != 'ashford') {
            store.dispatch(setIsAshford(false));
        } else {
            store.dispatch(setIsAshford(true));
        }
        navigate(`/locations/${locationSlug}`);
    };

    const changeStorageType = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const storageType = event.target.value;
        store.dispatch(setStorageType(storageType));
        if (storageType === 'vehicle') {
            store.dispatch(setStorageSize(0));
        }
        const personasTransformed = personas?.map((persona): Persona => {
            return {
                _id: persona._id,
                name: persona.name,
                enabled: persona.enabled,
                parameters: persona.parameters,
                deleted: false,
                sites: [],
                assignCustomerType: null,
                useForJourneySelection: false,
            };
        });
        if (setCurrentPersonaId) {
            setCurrentPersonaId(findPersonaId(storageType, personasTransformed));
        }
    };

    return (
        <>
            {!hideSelectors && (
                <div className={`${classes.journey_selectors}`}>
                    <div className={`${classes.location}`}>
                        <div>
                            <PinIcon width={14} />
                        </div>
                        <select
                            defaultValue={isAshford ? 'ashford' : location.slug}
                            onChange={changeLocation}
                        >
                            <option key={'Ashford'} value={'ashford'}>
                                Ashford
                            </option>
                            {locations.map((loc) => (
                                <option key={loc.name} value={loc.slug}>
                                    {loc?.name.replace('U-Store-It', '').length > 1
                                        ? loc?.name.replace('U-Store-It', '')
                                        : 'LSETUPS'}
                                </option>
                            ))}
                        </select>
                    </div>
                    {storageTypeSelect && personas?.length != 0 && (
                        <div className={`${classes.storage_type}`}>
                            <select
                                // defaultValue={storageType ? storageType : 'personal'}
                                onChange={changeStorageType}
                            >
                                {personas?.map((persona) => {
                                    if (persona.parameters[0].value === 'personal') {
                                        return (
                                            <option
                                                key={persona._id}
                                                value={`personal`}
                                                selected={storageType === 'personal'}
                                            >
                                                Personal Storage
                                            </option>
                                        );
                                    }
                                    if (persona.parameters[0].value === 'business') {
                                        return (
                                            <option
                                                key={persona._id}
                                                value={`business`}
                                                selected={storageType === 'business'}
                                            >
                                                Business Storage
                                            </option>
                                        );
                                    }
                                    if (persona.parameters[0].value === 'vehicle') {
                                        return (
                                            <option
                                                key={persona._id}
                                                value={`vehicle`}
                                                selected={storageType === 'vehicle'}
                                            >
                                                Vehicle Storage
                                            </option>
                                        );
                                    }
                                })}
                            </select>
                        </div>
                    )}
                </div>
            )}
        </>
    );
}

export default JourneySelectors;
